<template>
  <div>
    <v-toolbar color="secondary" dark tabs>
      <v-toolbar-title>{{$tc('design.property', 2)}}</v-toolbar-title>
      <v-tabs
        v-model="tabs"
        centered
        color="secondary"
        slot="extension"
        slider-color="accent"
      >
        <v-tab
          :href="`#tab-text${id}-general`"
          ripple
        >
          {{$t('general.general')}}
        </v-tab>
        <v-tab
          :href="`#tab-text${id}-states`"
          ripple
        >
          {{$tc('design.state', 2)}}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-card-text>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="`tab-text${id}-general`">
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <h3><b>{{$t('design.position')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="x"
                name="pos-x"
                label="X"
                id="pos-x"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="y"
                name="pos-y"
                label="Y"
                id="pos-y"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.size')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="w"
                name="size-w"
                :label="$t('design.width')"
                id="size-w"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="h"
                name="size-h"
                :label="$t('design.height')"
                id="size-h"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3>{{$t('design.alignment')}}</h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-select
                v-model="horizontalAlign"
                name="horizontal_align"
                label="Horizontal"
                :items="horizontalAlignmentSelect"
              ></v-select>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-select
                v-model="verticalAlign"
                name="vertical_align"
                label="Vertical"
                :items="verticalAlignmentSelect"
              ></v-select>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.padding')}}</b></h3>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingLeft"
                name="padding_left"
                :label="$t('design.left')"
                id="padding-left"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingTop"
                name="padding_top"
                :label="$t('design.top')"
                id="padding-top"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingRight"
                name="padding_right"
                :label="$t('design.right')"
                id="padding-right"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1 pb-0>
              <v-text-field
                v-model.number="paddingBottom"
                name="padding_bottom"
                :label="$t('design.bottom')"
                id="padding-bottom"
                type="number"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.zIndex')}}</b></h3>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model.number="zIndex"
                name="z-index"
                :label="$t('design.zIndex')"
                id="z-index"
                type="number"
                min="0"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0 pb-0>
              <h3><b>{{$tc('design.color', 2)}}</b></h3>
            </v-flex>
            <v-flex xs12 d-inline-flex pt-1 pb-0>
              <color-picker
                :color-type="'backgroundColor'"
                :label="$t('design.background')"
                :name="'background_color'"
              ></color-picker>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.text')}}</b></h3>
            </v-flex>
            <v-flex xs12 pt-1>
              <ckeditor
                v-model="text"
                :editor="editor"
                :config="editorConfig"
                @input="onEditorInput"
              ></ckeditor>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item :value="`tab-text${id}-states`">
          <widget-states></widget-states>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { mapWidgets } from './WidgetPropertiesUtils';
import WidgetPropertiesMixin from './WidgetPropertiesMixin';
import WidgetStates from './WidgetStates.vue';
import ColorPicker from './ColorPicker.vue';

export default {
  components: {
    WidgetStates,
    ColorPicker,
  },
  mixins: [WidgetPropertiesMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: 'dataText',
          key: 'text',
        },
        {
          path: 'style',
          key: 'horizontalAlign',
        },
        {
          path: 'style',
          key: 'verticalAlign',
        },
        {
          path: 'style',
          key: 'paddingLeft',
        },
        {
          path: 'style',
          key: 'paddingTop',
        },
        {
          path: 'style',
          key: 'paddingRight',
        },
        {
          path: 'style',
          key: 'paddingBottom',
        },
        {
          path: 'style',
          key: 'backgroundColor',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
      ],
    ),
  },
  data() {
    return {
      tabs: null,
      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ['ImageUpload', 'Table', 'MediaEmbed'],
      },
      horizontalAlignmentSelect: [
        { text: this.$i18n.t('design.left'), value: 'left' },
        { text: this.$i18n.t('design.center'), value: 'center' },
        { text: this.$i18n.t('design.right'), value: 'right' },
      ],
      verticalAlignmentSelect: [
        { text: this.$i18n.t('design.top'), value: 'top' },
        { text: this.$i18n.t('design.center'), value: 'center' },
        { text: this.$i18n.t('design.bottom'), value: 'bottom' },
      ],
    };
  },
  methods: {
    /* eslint-disable no-unused-vars */
    onEditorInput(eventInfo, batch) {
      const payload = {
        data: [
          {
            path: 'dataText',
            key: 'text',
            value: eventInfo,
          },
        ],
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
    },
    /* eslint-enable */
  },
};
</script>

<style scoped>

input:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.26) !important;
}

</style>
